export function queryObject(query) {
  if (typeof query !== 'object' || !query) {
    return {};
  }
  return Object.assign({}, query);
}